export default { sha: 'cd6aa120ec802696cf2a1f4329445b319f1bae56', buildNumber: 'undefined' }
